import { useSyncExternalStore } from "react";
import { toast } from "sonner";

const KEY = "eh_compare";
const listeners = new Set();
let cache = null;

const read = () => {
  if (cache === null) {
    try { cache = JSON.parse(localStorage.getItem(KEY)) || []; } catch { cache = []; }
  }
  return cache;
};
const write = (v) => {
  cache = v;
  localStorage.setItem(KEY, JSON.stringify(v));
  listeners.forEach((l) => l());
};
const subscribe = (l) => { listeners.add(l); return () => listeners.delete(l); };

export function useCompare() {
  const items = useSyncExternalStore(subscribe, read);
  const has = (id) => items.some((i) => i.id === id);
  const toggle = (c) => {
    if (has(c.id)) return write(items.filter((i) => i.id !== c.id));
    if (items.length >= 3) return toast.error("You can compare up to 3 communities. Remove one first.");
    write([...items, { id: c.id, name: c.name, city: c.city, state_code: c.state_code }]);
    toast.success(`${c.name} added to compare`);
  };
  const remove = (id) => write(items.filter((i) => i.id !== id));
  const clear = () => write([]);
  return { items, has, toggle, remove, clear };
}
